import { render, staticRenderFns } from "./btnUpdateData.vue?vue&type=template&id=5ffd9bb2&scoped=true&"
import script from "./btnUpdateData.vue?vue&type=script&lang=js&"
export * from "./btnUpdateData.vue?vue&type=script&lang=js&"
import style0 from "./btnUpdateData.vue?vue&type=style&index=0&id=5ffd9bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd9bb2",
  null
  
)

export default component.exports